import React, { useEffect } from 'react';
import './index.scss';
import { API_URL } from "../../../../../constants/ApplicationUrl";
import { underscoreToSpace } from '../../../../../dependencies/utils/helper';
function EemploymentCreation({ data, adminScores, setAdminScores }) {



  useEffect(() => {
    setAdminScores({
      directEmployment: data?.ScoreCard?.score?.adminScore?.directEmployment,
      pwdFemaleEmploymentCount: data?.ScoreCard?.score?.adminScore?.pwdFemaleEmploymentCount,
      employeeNonMetroCities: data?.ScoreCard?.score?.adminScore?.employeeNonMetroCities,
    });
  }, [data]);

  const handleScoreChange = (field, value) => {
    setAdminScores((prev) => ({
      ...prev,
      [field]: Number(value),
    }));
  };

  return (
    <div className="entity-detail-inner table-card">
      <table>
        <thead>
          <tr>
            <th className="score-marks">
              <table>
                <tr>
                  <th>
                    Employment Creation <span>(Max Marks : 100)</span>
                  </th>
                  <th>SIH User Marks</th>
                  <th>Admin Response</th>
                  <th>Admin <br/>Marks</th>
                </tr>
              </table>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="tbody">
              <table>
                <tr>
                  <td className='self-td'>
                    <div className="row-ca">
                      <div className="content">
                        <h6>Direct Employment</h6> <span>:</span>

                      </div>
                      <div className="view-list">
                        <p>
                          {underscoreToSpace(data?.Parameters?.broadParameter?.directEmployment)}
                          {data?.Parameters?.broadParameter?.directEmploymentDocument ? (<a href={`${API_URL()}${data?.Parameters?.broadParameter?.directEmploymentDocument?.publicUrl}`}
                            target="_blank"
                            rel="noopener noreferrer">View Document</a>):(null)}                         

                        </p>

                      </div>
                    </div>
                  </td>
                  <td className='marks-user'>{data?.ScoreCard?.score?.sihScore?.directEmployment}</td>
                  <td className='res-select'>
                    <select
                      className="form-select"
                      value={adminScores.directEmployment}
                      onChange={(e) => handleScoreChange("directEmployment", e.target.value)}
                    >
                      {data?.ScoreCard?.score ? (null):(<option value=''>--Select One--</option>)}
                      
                      <option value='10'>EMP LESS 20</option>
                      <option value="20">EMP 21-50</option>
                      <option value='30'>EMP 51-100</option>
                      <option value="40">EMP ABOVE 100</option>
                    </select>
                  </td>
                  <td className='adminmarks'>{adminScores?.directEmployment}</td>
                </tr>
                <tr>
                  <td>
                    <div className="row-ca">
                      <div className="content">
                        <h6>Employment of Females, Persons with Disabilities, Persons from SC ST categories</h6> <span>:</span>

                      </div>
                      <div className="view-list">
                        <p>
                          {underscoreToSpace(data?.Parameters?.broadParameter?.pwdFemaleEmploymentCount)}
                          {data?.Parameters?.broadParameter?.pwdFemaleEmploymentCountDocument ? (<a href={`${API_URL()}${data?.Parameters?.broadParameter?.pwdFemaleEmploymentCountDocument?.publicUrl}`}
                            target="_blank"
                            rel="noopener noreferrer">View Document</a>):(null)}
                          

                        </p>

                      </div>
                    </div>
                  </td>
                  <td>{data?.ScoreCard?.score?.sihScore?.pwdFemaleEmploymentCount}</td>
                  <td>
                    <select
                      className="form-select"
                      value={adminScores.pwdFemaleEmploymentCount}
                      onChange={(e) => handleScoreChange("pwdFemaleEmploymentCount", e.target.value)}
                    >
                      {data?.ScoreCard?.score ? (null):(<option value=''>--Select One--</option>)}
                      <option value='00'>PERCENT 0</option>
                      <option value="10">PERCENT 1-25</option>
                      <option value='20'>PERCENT 25-50</option>
                      <option value="30">PERCENT ABOVE 50</option>
                    </select>
                  </td>
                  <td>{adminScores?.pwdFemaleEmploymentCount}</td>
                </tr>
                <tr>
                  <td>
                    <div className="row-ca">
                      <div className="content">
                        <h6>Employees based in Non Metro Cities</h6> <span>:</span>

                      </div>
                      <div className="view-list">
                        <p>
                          {underscoreToSpace(data?.Parameters?.broadParameter?.employeeNonMetroCities)}
                          {data?.Parameters?.broadParameter?.employeeNonMetroCitiesDocument ? (<a href={`${API_URL()}${data?.Parameters?.broadParameter?.employeeNonMetroCitiesDocument?.publicUrl}`}
                            target="_blank"
                            rel="noopener noreferrer">View Document</a>): (null)}
                          

                        </p>

                      </div>
                    </div>
                  </td>
                  <td>{data?.ScoreCard?.score?.sihScore?.employeeNonMetroCities}</td>
                  <td>  <select
                    className="form-select"
                    value={adminScores.employeeNonMetroCities}
                    onChange={(e) => handleScoreChange("employeeNonMetroCities", e.target.value)}
                  >
                    {data?.ScoreCard?.score ? (null):(<option value=''>--Select One--</option>)}
                    <option value='0'>PERCENT 0</option>
                    <option value="10">PERCENT 1-25</option>
                    <option value='20'>PERCENT 25-50</option>
                    <option value="30">PERCENT ABOVE 50</option>
                  </select></td>
                  <td>{adminScores?.employeeNonMetroCities}</td>
                </tr>

              </table>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td className="tfoot">
              <table>

                <tr>
                  <td>
                    <h6>Sectional Marks Obtained <span>SIH User Marks </span></h6>
                  </td>
                  <td>{data?.ScoreCard?.score?.sihScore?.totalGroup3Score}</td>
                  <td>Admin Marks</td>
                  <td>{adminScores?.employeeNonMetroCities + adminScores?.pwdFemaleEmploymentCount + adminScores?.directEmployment}</td>
                  {/* <td>{data?.ScoreCard?.score?.adminScore?.totalGroup3Score}</td> */}

                </tr>
              </table>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  )
}

export default EemploymentCreation
